import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import { Alert } from "react-bootstrap";
import Pagination from "react-js-pagination";
import GeneralFilter from "../../../components/GeneralFilter";
import AttentionCenterZurichTable from "./AttentionCenterZurichTable";
import { getCasesByStatuses } from "../../services/casesService";
import CaseContext from "../../../contexts/CaseContext";

const AttentionCenterZurich = () => {
  window.currModule = "Centro de Atención Zurich";
  window.assignationColumn = "feaCentroAtencion";

  const suhbeader = useSubheader();
  suhbeader.setTitle("Centro de Atención Zurich");

  const [casesRecord, setCasesRecord] = useState([]);
  const [paramsPagination, setParamsPagination] = useState({
    activePage: 1,
    totalPages: null,
    itemsCountPerPage: null,
    totalItemsCount: 0,
  });

  const getAllCasesByStatus = (pageNumber) => {
    getCasesByStatuses([11], pageNumber, ['&byRegion=true', '&byCell=true']).then((response) => {
      setCasesRecord(response.data);
      setParamsPagination({
        activePage: pageNumber,
        totalPages: response.totalPages,
        itemsCountPerPage: response.size,
        totalItemsCount: response.totalElements,
      });
    });
  };

  const handlePageChange = async (pageNumber) => {
    setParamsPagination({ ...paramsPagination, activePage: pageNumber, updatePage: true });

    if (!paramsPagination.hasOwnProperty("fromFilter")) {
      getAllCasesByStatus(pageNumber);
    }
  };

  useEffect(() => {
    getAllCasesByStatus(paramsPagination.activePage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Alert
        variant="success"
        className="text-center"
        style={{ fontSize: "16px" }}
      >
        Centro de Atención Zurich
      </Alert>

      <CaseContext.Provider value={[
        casesRecord, setCasesRecord,
        paramsPagination, setParamsPagination
      ]}>
        <GeneralFilter
          statuses={[11]}
          hideHospitalCategory={false}
          hideFolioEp={false}
          hideIncomeType={false}
          hideInsurance={true}
          hideTypePolicy={true}
          hideMovementType={true}
          hidePresumptiveDiagnosis={true}
          hideAxaCategoryId={true}
          hideCategoryVip={true}
          hideHospitalInvoice={true}
          hideComprehensiveCare={true}
        />
      </CaseContext.Provider>

      <AttentionCenterZurichTable
        urlToGo="/centro_atencion_zurich_detalles/"
        data={casesRecord}
        activePage={paramsPagination.activePage}
      />

      <div className="d-flex justify-content-center">
        <Pagination
          activePage={paramsPagination.activePage}
          itemsCountPerPage={paramsPagination.itemsCountPerPage}
          totalItemsCount={paramsPagination.totalItemsCount}
          pageRangeDisplayed={10}
          itemClass="page-item"
          linkClass="btn btn-light"
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default AttentionCenterZurich;
